/**
 * Button.js
 * Created by calhosh on 6/15/2020.
 */

import {MotifButton} from '@ey-xd/motif-react';
import React from 'react';

export default function Button({
	disabled,
	size,
	stepper,
	type,
	variant,
	children,
	...props
}) {
	return (
		<MotifButton
			variant={variant}
			disabled={disabled}
			size={size}
			type={type}
			stepper={stepper}
			{...props}
		>
			{children}
			{props.label}
		</MotifButton>
	);
}
